import type { TranslationTree } from '../locale.model';

export const commonPtBr: TranslationTree = {
  app: {
    name: 'Fisital.ai',
    product: 'License Manager',
  },
  cancel: 'Cancelar',
  save: 'Salvar',
  saveChanges: 'Salvar alterações',
  saving: 'Salvando…',
  savingEllipsis: 'Salvando...',
  delete: 'Excluir',
  deleting: 'Excluindo...',
  edit: 'Editar',
  remove: 'Remover',
  close: 'Fechar',
  ok: 'OK',
  create: 'Criar',
  add: 'Adicionar',
  back: 'Voltar',
  retry: 'Tentar novamente',
  confirmDelete: 'Confirmar exclusão',
  confirmDeleteQuestion: 'Deseja realmente excluir',
  loading: 'Carregando…',
  noResults: 'Nenhum resultado encontrado.',
  actions: 'Ações',
  name: 'Nome',
  description: 'Descrição',
  status: 'Status',
  email: 'E-mail',
  phone: 'Telefone',
  select: 'Selecione',
  all: 'Todos',
  allFeminine: 'Todas',
  active: 'Ativo',
  inactive: 'Inativo',
  activeFeminine: 'Ativa',
  inactiveFeminine: 'Inativa',
  undefined: 'Indefinido',
  rows: 'Linhas',
  page: 'Página',
  of: 'de',
  total: 'no total',
  registered: 'Cadastrados',
  registeredCount: '{{count}} cadastrado(s)',
  yes: 'SIM',
  no: 'NÃO',
  filters: 'Filtros:',
  search: 'Buscar',
  exportPdf: 'Exportar PDF',
  width: 'Largura',
  icon: 'Ícone',
  type: 'Tipo',
  code: 'Código',
  region: 'Região',
  clients: 'Clientes',
  category: 'Categoria',
  section: 'Seção',
  path: 'Caminho',
  marker: 'Marcador',
  optional: 'opcional',
  noFile: 'Nenhum arquivo selecionado',
  noPreview: 'Sem preview',
  noFileShort: 'Sem arquivo',
  browse: 'Browse',
  expandAll: 'Expandir tudo',
  collapseAll: 'Colapsar tudo',
  selectAll: 'Marcar todas',
  deselectAll: 'Desmarcar todas',
  activateAll: 'Ativar Todos',
  deactivateAll: 'Desativar Todos',
  details: 'Detalhes',
  preview: 'Preview',
  validation: 'Validação',
  theme: {
    light: 'Ativar tema claro',
    dark: 'Ativar tema escuro',
  },
  installation: {
    cloud: 'Cloud',
    onpremise: 'On-premise',
    hybrid: 'Híbrido',
  },
  menuBullet: {
    bullet: 'Bullet (ponto)',
    line: 'Line (linha)',
  },
  lang: {
    ptBr: 'Português (BR)',
    pt: 'Português',
    en: 'English',
    es: 'Español',
  },
  pagination: {
    total: '({{total}} no total)',
    updating: 'Atualizando a lista…',
  },
  errors: {
    apiConnection: 'Não foi possível conectar à API. Verifique a URL e CORS.',
    httpStatus: 'Erro {{status}}',
    invalidCompanyResponse: 'Resposta inválida ao salvar a empresa.',
    invalidProfileCreateResponse: 'Resposta inválida ao criar perfil.',
    invalidProfileResponse: 'Resposta inválida de perfil.',
    invalidResetPasswordResponse: 'Resposta inválida ao redefinir senha.',
    invalidUserResponse: 'Resposta inválida ao criar utilizador.',
    missingNewPassword: 'A API não devolveu a nova senha temporária.',
    missingTemporaryPassword: 'A API não devolveu a senha temporária do novo utilizador.',
    loginFailed: 'Falha no login. Tente novamente.',
  },
};

export const authPtBr: TranslationTree = {
  welcome: 'Bem-vindo',
  subtitle: 'Entre com suas credenciais',
  usernameLabel: 'E-mail ou usuário',
  usernamePlaceholder: 'seu@email.com',
  passwordLabel: 'Senha',
  passwordPlaceholder: '••••••••',
  showPassword: 'Mostrar senha',
  hidePassword: 'Ocultar senha',
  submit: 'Entrar',
  submitting: 'Entrando…',
  configLoading: 'Carregando…',
  retryConfig: 'Tentar novamente',
  error: {
    fillCredentials: 'Preencha usuário e senha.',
  },
};

export const navPtBr: TranslationTree = {
  main: 'Principal',
  companies: 'Empresas',
  manufacturers: 'Fabricantes',
  resellers: 'Revendedores',
  operators: 'Gestão de Operadores',
  parameterizations: 'Parametrizações',
  menus: 'Menus',
  tickets: 'Central de Chamados',
  knowledgeBase: 'Base de Conhecimento',
  ambience: 'Ambiência',
  colorPalettes: 'Paletas de cores',
  collapse: 'Recolher',
  collapseAria: 'Recolher ou expandir menu',
  plansPro: 'Planos Pro',
  upgradeEnterprise: 'Fazer Upgrade Enterprise',
  validUntil: 'Válido até 31 dezembro 2026',
  languageAria: 'Idioma: {{locale}}',
  notificationsAria: 'Notificações, 3 novas',
  accountMenuAria: 'Menu da conta',
  userFallback: 'Usuário',
  myProfile: 'Meu Perfil',
  logout: 'Sair',
};

export const dashboardPtBr: TranslationTree = {
  title: 'Dashboard',
  subtitle: 'Visão geral do licenciamento, operações e consumo',
  planPro: 'Plano Pro',
  upgrade: 'Fazer Upgrade',
  alerts: {
    title: 'Alertas ativos',
    llmTitle: 'Tokens LLM — 90% da capacidade',
    llmBody: 'Aproxime-se do limite do pacote contratado.',
    conversationsTitle: 'Conversas — 78% da capacidade',
    conversationsBody: 'Monitore o volume para evitar bloqueios.',
  },
  metrics: {
    aria: 'Métricas principais',
    operators: 'Operadores',
    active: 'ativos',
    activeModules: 'Módulos ativos',
    available: 'disponíveis',
    contractDeadline: 'Prazo do contrato',
    days: 'dias',
    nextBilling: 'Próximo faturamento',
    billingStatus: 'Boleto · Em dia',
  },
  verticals: {
    title: 'Verticais ativas',
    banking: 'Bancos',
    retail: 'Varejo',
    industry: 'Indústria',
    active: 'Ativo',
  },
  resources: {
    title: 'Recursos licenciados',
    cameras: 'Câmeras',
    locations: 'Locais',
    users: 'Usuários',
    storage: 'Armazenamento',
  },
  userDistribution: {
    title: 'Distribuição de usuários',
    admins: 'Admin',
    operators: 'Operadores',
    viewers: 'Visualizadores',
  },
  ai: {
    title: 'IA & Consumo',
    apiRequests: 'Requisições API',
    inferenceJobs: 'Jobs de inferência',
    avgStorage: 'Armazenamento médio',
    perMonth: 'no mês',
    completed: 'concluídos',
    perProject: 'por projeto',
  },
};
